/**
 * Table Script.
 */
import AddTable from './addTable';

const tableContainers = [...document.querySelectorAll('.em-tables__table')];
if (tableContainers) {
	tableContainers.map((el) => new AddTable(el));
}
